import { CIcon } from '~/icons/types'
export const ciDoors: CIcon = {
  width: 512,
  height: 492.9,
  paths: [
    {
      d:
        'M509.6 269.9v-94c0-35 0-71.3-.1-106.7 0-40.5-26-68.9-63-69.1-31.2-.1-57-.1-87.7-.1h-46.6c-30.1 0-54.5 11.3-70.7 32.6-25.5 33.6-65.6 86.2-94.8 124.5-13.3 17.5-24.2 31.7-30 39.4-5.8 7.6-10.1 15.3-13 23.2-1 1.5-1.6 3.4-1.7 5.3-1.7 6-2.5 12.1-2.5 18.3v64.5c-.1 50.5-.1 63.7.1 117.1.2 40 26 67.9 62.8 67.9 52.4.1 100.4.1 148.9.1s80.5 0 134.9-.1c37.9 0 63.4-28 63.4-69.6V270.9c.1-.4 0-.7 0-1zm-346.1-100c29.3-38.4 69.4-90.9 94.9-124.6C270.6 29.2 288.7 21 312.3 21h46.6c30.7 0 56.4 0 87.6.1 25.5.1 42.1 19 42.1 48.1.1 35.5.1 71.7.1 106.7v39H129.5c1.2-1.9 2.5-3.8 4-5.7 5.8-7.6 16.6-21.8 30-39.3zm325.2 253.4c0 30-16.3 48.6-42.4 48.6-108.8.1-178.9.1-283.7 0-25.3 0-41.7-18.5-41.9-47-.2-53.3-.2-66.6-.1-117v-64.5c0-2.5.2-5 .6-7.4h367.4v187.3h.1z'
    },
    {
      d:
        'M427.3 280.3h-73.5c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h73.5c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5z'
    },
    {
      d:
        'M23.6 242.6c0-1.6.1-3.1.3-4.7h47.4c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H32.5c.5-.7 1.1-1.5 1.6-2.2 4.9-6.4 14.1-18.5 25.4-33.3 24.8-32.5 58.7-76.9 80.3-105.5 10-13.2 24.9-19.9 44.3-19.9h7.8c5.8 0 10.5-4.7 10.5-10.5S197.7 35 191.9 35h-7.8c-26 0-47.1 9.8-61.1 28.3-21.6 28.5-55.5 72.9-80.3 105.4-11.1 14.8-20.4 26.8-25.3 33.3-5 6.6-8.7 13.2-11.2 19.9-.9 1.4-1.4 3.1-1.6 4.9-1.4 5.2-2.1 10.4-2.1 15.8v54.6c-.1 42.6-.1 52.7.1 97.6.2 34.8 22.7 59.1 54.8 59.1h13.8c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H57.5c-20.4 0-33.7-15-33.8-38.2-.1-44.8-.1-54.9-.1-97.5v-54.6z'
    }
  ],
  name: 'doors',
  type: 'regular'
}
